<template>
  <v-app>
      <navbar v-if="!$route.meta.isDialogPage" ></navbar>
      <v-main id="main-app" :style="{'background-color':'#fafafa','padding-top':
      (!$route.meta.isDialogPage && !getSearchBar) ? '56px':'56px'}"
      >
          <v-container pa-0 grid-list-lg>
              <router-view></router-view>
          </v-container>
      </v-main>
  </v-app>
</template>

<script>
import navbar from "./components/navbar";
import request from "./store/curl";

export default {
  name: "app",
    components: {navbar},
    data () {
    return {};
    },
    computed: {
      userData() {
        return this.$store.getters.userData;
      },
      loggedIn() {
        return this.$store.getters.loggedIn;
      },
      getSearchBar() {
        return this.$store.getters.getSearchBar;
      }
    },
    mounted() {
      /* Register go_to_participant_profile function globally in our project
      *  this function is helpfull if you make hard html from any function and component rether then vue
      *  currently is call in utility.replaceUserIdMicro
      * because we can not pass object from hard html
      *
      * window.go_to_participant_profile
      */
      window.go_to_participant_profile = (participant_id) => {
        this.$store.commit('setParticipantId', participant_id);
        this.$router.push({name:'participant_profile'});
      }

    //Save this is Session Storage. Whenever this is not found, means user profile data needs to be updated
      if (!window.sessionStorage.getItem("browserOpen")) {
        this.getUserProfile();
        window.sessionStorage.setItem("browserOpen", true);
      }
    },
    methods:{
      /**
       * getUserProfile
       * 
       */  
      getUserProfile(){
        let ud = this.userData;
        if ((!ud || !ud.user_id) || !ud.is_verified) {
          //Dont get profile data if profile is not verfied. There will be problem in case case of Activate, Register, ForgotPassword. 
          //User will logout as token may not validate
          return false;
      }

        var post_data = new FormData();
        post_data.append("chat_user_id", ud.user_id);
        request.curl(this, "user_profile_view", post_data)
        .then(response => {
          this.loading = false;
          if(response.resp_status){
            if (response.resp_data.source == "GIDEMKTINGCHATBOT") {
              // set the 'is_verified' key in user_data to true, so that the navbar becomes visible, 
              response.resp_data.is_verified = true
            }
            this.$store.commit("setUserProfile", response.resp_data);
          }
          else{
            this.response_message = response.resp_msg;
            this.is_error = true;
          }
        });
      }
    }
};
</script>
